function parseBooleanEnv(value: string | undefined, defaultValue: boolean): boolean {
  if (value === undefined) {
    return defaultValue;
  }

  const normalized = value.trim().toLowerCase();
  if (['1', 'true', 'yes', 'on'].includes(normalized)) {
    return true;
  }

  if (['0', 'false', 'no', 'off'].includes(normalized)) {
    return false;
  }

  return defaultValue;
}

export const slaEsignConfig = {
  publicSigningEnabled: parseBooleanEnv(import.meta.env.VITE_SLA_ESIGN_PUBLIC_SIGNING_ENABLED, true),
  finalDeliveryRetryEnabled: parseBooleanEnv(
    import.meta.env.VITE_SLA_ESIGN_FINAL_DELIVERY_RETRY_ENABLED,
    true
  ),
} as const;
